
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const showModal = (modalType, data, api, message) => ({
    type: SHOW_MODAL,
    payload: { modalType, data, api, message},
  });
  
  export const hideModal = () => ({
    type: HIDE_MODAL,
  });